import HelpIcon from "@mui/icons-material/Help";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { ReactElement } from "react";

type privilege = {
  name: string;
  action: string;
};

type route = {
  title: string;
  path: string;
  privilege?: privilege;
};

type routeGroup = {
  groupTitle: string;
  privilege?: privilege;
  routes: route[];
  icon: ReactElement<any>;
};

export const routes: routeGroup[] = [
  {
    groupTitle: "titles.cardManagement",
    icon: <ManageSearchIcon />,
    privilege: {
      name: "EFK.CARD",
      action: "READ",
    },
    routes: [
      {
        title: "titles.searchCard",
        path: "/search-card",
        privilege: {
          name: "EFK.CARD",
          action: "READ",
        },
      },
      {
        title: "titles.administration.card",
        path: "/administrate-card",
        privilege: {
          name: "EFK.CARD.ADMIN.MODIFY",
          action: "WRITE",
        },
      },
      {
        title: "titles.searchLogs",
        path: "/search-logs",
        privilege: {
          name: "EFK.LOG",
          action: "READ",
        },
      },
      {
        title: "titles.searchOwnLogs",
        path: "/search-own-logs",
        privilege: {
          name: "EFK.LOG.READOWN",
          action: "READ",
        },
      },
      {
        title: "titles.settings",
        path: "/unit-settings",
        privilege: {
          name: "EFK.USER.SETTINGS.MODIFY",
          action: "WRITE",
        },
      },
      {
        title: "titles.statistics",
        path: "/statistics",
        privilege: {
          name: "EFK.STATISTICS",
          action: "READ",
        },
      },
      {
        title: "titles.administration.careprincipal",
        path: "/careprincipal",
        privilege: {
          name: "EFK.CAREPRINCIPAL.MODIFY",
          action: "WRITE",
        },
      },
      {
        title: "titles.cardTypes",
        path: "/administration/cardtypes",
        privilege: {
          name: "EFK.CARD.TYPE",
          action: "WRITE",
        },
      },
      {
        title: "titles.group",
        path: "/administration/group",
        privilege: {
          name: "EFK.CARD.MODIFY",
          action: "WRITE",
        },
      },
      {
        title: "titles.contract",
        path: "/contract",
        privilege: {
          name: "EFK.CONTRACT",
          action: "READ",
        },
      },
    ],
  },
  {
    groupTitle: "titles.administration.root",
    icon: <ManageAccountsIcon />,
    privilege: {
      name: "ADMIN",
      action: "READ",
    },
    routes: [
      {
        title: "titles.administration.authorization",
        path: "/administration/authorization",
        privilege: {
          name: "ADMIN",
          action: "READ",
        },
      },
      {
        title: "titles.administration.add.careprincipal",
        path: "/administration/add-careprincipal",
      },
      {
        title: "titles.administration.add.cardtypes",
        path: "/administration/add-cardtypes",
      },
      {
        title: "titles.administration.system.status",
        path: "/administration/system-status",
      },
      {
        title: "titles.administration.general.configuration",
        path: "/administration/general-config",
      },
      {
        title: "titles.administration.fileimport",
        path: "/administration/fileimport",
      },
      {
        title: "titles.administration.HSA",
        path: "/administration/hsa-import",
      },
      {
        title: "titles.administration.info",
        path: "/administration/info",
      },
      {
        title: "titles.administration.trustmanager",
        path: "/administration/trustmanager",
      },
      {
        title: "titles.administration.keygroup",
        path: "/administration/keygroup",
      },
    ],
  },
  {
    groupTitle: "titles.help.root",
    icon: <HelpIcon />,
    routes: [
      {
        title: "titles.help.user.info",
        path: "/user",
      },
      {
        title: "titles.help.logout",
        path: "/logout",
      },
    ],
  },
];
